"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.GROW_MS = exports.EXIT_MS = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Styles for the full-screen candidate view. The picture's growth from
 * where it was tapped depends on where that was, so the component drives
 * it; the ground's fade and the actions' arrival are here.
 */ // What the picture leaves the window for everything under it and the
// margins around it: the actions, the details, and the gaps between.
const ROOM_BELOW = "10rem";
const groundIn = "x18re5ia-B";
const groundOut = "x1jn504y-B";
const actionsIn = "x369kmj-B";
const actionsOut = "xtvb0qs-B"; // How long the ground takes to darken: slower than the picture's growth,
// so the room dims around a picture that is already there.
const GROUND_MS = 420; // How long the picture takes to grow into place, and to shrink back.
const GROW_MS = exports.GROW_MS = 320; // How long the exit runs before the view unmounts: the picture's return,
// with the ground fading over it.
const EXIT_MS = exports.EXIT_MS = 260;
const styles = exports.styles = {
  overlay: {
    position: "xixxii4",
    top: "x13vifvy",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    right: "x3m8u43",
    bottom: "x1ey2m1c",
    zIndex: "x11uqc5h",
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    boxSizing: "x9f619",
    backgroundColor: "x16h7yo4",
    animationName: "xqcmdr3",
    animationDuration: "xmprevt x1u6grsq",
    animationTimingFunction: "xa3vuyk",
    animationFillMode: "x1u6ievf",
    $$css: true
  },
  overlayOut: {
    animationName: "xxp0q0x",
    animationDuration: "x1g18oiy x1u6grsq",
    animationTimingFunction: "x1debuo4",
    animationFillMode: "x10e4vud",
    $$css: true
  },
  view: {
    position: "x1n2onr6",
    zIndex: "x1rozsjd",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    width: "xh8yej3",
    height: "x5yr21d",
    minHeight: "x2lwn1j",
    $$css: true
  },
  stage: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    flexShrink: "xs83m0k",
    minHeight: "x2lwn1j",
    width: "xh8yej3",
    maxHeight: "xmz0i5r",
    $$css: true
  },
  frame: {
    position: "x1n2onr6",
    display: "x78zum5",
    flexShrink: "xs83m0k",
    minHeight: "x2lwn1j",
    maxWidth: "x193iq5w",
    $$css: true
  },
  picture: {
    display: "x1lliihq",
    maxWidth: "x193iq5w",
    maxHeight: "x10dvs0s",
    width: "x14atkfc",
    height: "xt7dq6l",
    objectFit: "x19kjcj4",
    borderRadius: "x116uinm",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    transformOrigin: "x1g0ag68",
    $$css: true
  },
  close: {
    position: "x10l6tqk",
    top: "x18c3ff5",
    right: "xhq84gp",
    insetInlineStart: null,
    insetInlineEnd: null,
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    padding: "x78pyy4",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderWidth: "xc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    backgroundColor: "xjbqb8w",
    color: "x1f7m26b",
    opacity: "xuzhngd x1c3glr3 x8tgox0",
    filter: "xrd23x4",
    cursor: "x1ypdohk",
    transition: "x1kp8z7 x9kvfbb",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  actions: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    gap: "x1rkdry8",
    rowGap: null,
    columnGap: null,
    flexShrink: "x2lah0s",
    animationName: "xkf8w2b",
    animationDuration: "xw6taxk x1u6grsq",
    animationDelay: "x1jh9esf x14q22ui",
    animationTimingFunction: "xatqbsq",
    animationFillMode: "x1u6ievf",
    $$css: true
  },
  actionsOut: {
    animationName: "xokcgd3",
    animationDuration: "x1shwlz2 x1u6grsq",
    animationDelay: "x1uzojwf",
    animationTimingFunction: "x1debuo4",
    animationFillMode: "x10e4vud",
    $$css: true
  },
  details: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    gap: "xvh977a",
    rowGap: null,
    columnGap: null,
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    textAlign: "x2b8uid",
    color: "x12y22ox",
    $$css: true
  },
  name: {
    fontFamily: "xm3uy08",
    fontSize: "x1gqo1bu",
    fontWeight: "x1s688f",
    overflowWrap: "xj0a0fe",
    $$css: true
  },
  meta: {
    fontFamily: "x1wl88yq",
    fontSize: "x1nrrp6k",
    opacity: "x18km98s",
    $$css: true
  },
  source: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "x73f2yu",
    rowGap: null,
    columnGap: null,
    maxWidth: "x193iq5w",
    marginTop: "x1tbvfm1",
    $$css: true
  },
  url: {
    fontFamily: "xm3uy08",
    fontSize: "xgommxb",
    color: "x1fz36lf x1qfsr1m",
    textDecoration: "x1hl2dhg xt0b8zv",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    overflowWrap: "xj0a0fe",
    $$css: true
  }
};